import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import LogoPoweredByGala from '~/components/UIComponents/LogoPoweredByGala.vue';
import LogoGalaFilm from '~/components/UIComponents/LogoGalaFilm.vue';
import { useSanityCta } from '~/composables/useSanityCta';
import { IRedemptionState } from '~/types/promo-box';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import PromoBackground from './PromoBackground.vue';
import PromoBoxShare from './PromoBoxShare.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBox',
  props: {
    canRedeem: { type: Boolean, default: true },
    doc: null,
    loading: { type: Boolean },
    redemptionState: { default: IRedemptionState.REDEEMABLE },
    redeeming: { type: Boolean, default: false },
    titleTag: { default: 'h1' }
  },
  emits: ["redeem", "info"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'redeem'): void;
  (e: 'info'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { canRedeem: boolean, doc?: ISanityDocuments[SanityDocumentSchema.PROMO_BOX], loading?: boolean, redemptionState: IRedemptionState, redeeming: boolean, titleTag: 'h1' | 'h2' }





const content = computed(() => {
  switch (props.redemptionState) {
    case IRedemptionState.REDEEMED:
      return props.doc?.redeemedContent;
    case IRedemptionState.EXPIRED:
      return props.doc?.redemptionExpiredContent;
    default:
      return props.doc?.redeemableContent;
  }
});

const ctaText = computed(() => {
  switch (props.redemptionState) {
    case IRedemptionState.REDEEMED:
      return props.doc?.redeemedCtaText;
    case IRedemptionState.EXPIRED:
      return props.doc?.redemptionExpiredCtaText;
    default:
      return props.doc?.redeemableCtaText ?? 'Open now';
  }
});

const ctaProps = {
  class: 'rounded-pill black--text font--button',
  color: 'white',
  depressed: true,
  large: true,
};

const urlOrReflink = computed(() => {
  switch (props.redemptionState) {
    case IRedemptionState.REDEEMED:
      return props.doc?.redeemedCta;
    case IRedemptionState.EXPIRED:
      return props.doc?.redemptionExpiredCta;
    default:
      return;
  }
});

const { href, isExternalLink, isLoading, target } = useSanityCta(urlOrReflink);

// temp log redemption code for testing
watch(
  () => props.doc?.redemptionCode,
  (current) => {
    if (current) {
      console.log(`######## -- Redemption Code -- ########`);
      console.log(current);
      console.log(`######## -- Redemption Code -- ########`);
    }
  },
  { immediate: true },
);

return { __sfc: true,props, emit, content, ctaText, ctaProps, urlOrReflink, href, isExternalLink, isLoading, target, LogoPoweredByGala, LogoGalaFilm, IRedemptionState, PromoBackground, PromoBoxShare }
}

})